module.exports = __webpack_public_path__ + "static/media/H1_GLOSS.afc6c5e7.png";